var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Helmet } from 'react-helmet';
import RouteHandler from "../App/RouteHandler";
import LibraryCharts from "../Charts/components/LibraryCharts";
import { t } from "../I18N";
import { enterLibrary, unsetDocuments } from "../Library/actions/libraryActions";
import { processQuery } from "../Library/helpers/requestState";
import DocumentsList from "../Library/components/DocumentsList";
import LibraryFilters from "../Library/components/LibraryFilters";
import SearchButton from "../Library/components/SearchButton";
import ViewMetadataPanel from "../Library/components/ViewMetadataPanel";
import SelectMultiplePanelContainer from "../Library/containers/SelectMultiplePanelContainer";
import libraryHelpers from "../Library/helpers/libraryFilters";
import { wrapDispatch } from "../Multireducer";
import api from "../Search/SearchAPI";
import ImportPanel from "./components/ImportPanel";
import UploadBox from "./components/UploadBox";
import UploadsHeader from "./components/UploadsHeader";

import setReduxState from "../Library/helpers/setReduxState";
import rison from 'rison-node';
import { socket } from "../socket";

export default class Uploads extends RouteHandler {
  constructor(props, context) {
    super(props, context);
    this.refreshSearch = this.refreshSearch.bind(this);
  }

  static renderTools() {
    return /*#__PURE__*/(
      _jsx("div", { className: "searchBox" }, void 0, /*#__PURE__*/
      _jsx(SearchButton, { storeKey: "uploads" })));


  }

  urlHasChanged(nextProps) {
    return nextProps.location.query.q !== this.props.location.query.q;
  }

  emptyState() {
    wrapDispatch(this.context.store.dispatch, 'uploads')(unsetDocuments());
  }

  static async requestState(requestParams, globalResources) {
    const query = processQuery(requestParams.data, globalResources, 'uploads');
    query.unpublished = true;

    const documents = await api.search(requestParams.set(query));
    const filterState = libraryHelpers.URLQueryToState(
    query,
    globalResources.templates.toJS(),
    globalResources.relationTypes.toJS());


    const addinsteadOfSet = Boolean(query.from);

    return [
    setReduxState(
    {
      uploads: {
        documents,
        filters: {
          documentTypes: query.types || [],
          properties: filterState.properties
        },
        aggregations: documents.aggregations,
        search: filterState.search
      }
    },
    'uploads',
    addinsteadOfSet)];


  }

  refreshSearch() {
    super.getClientState(this.props);
  }

  componentDidMount() {
    const dispatch = wrapDispatch(this.context.store.dispatch, 'uploads');
    socket.on('IMPORT_CSV_END', this.refreshSearch);
    dispatch(enterLibrary());
  }

  componentWillUnmount() {
    socket.removeListener('IMPORT_CSV_END', this.refreshSearch);
    this.emptyState();
  }

  componentDidUpdate(prevProps) {
    if (this.urlHasChanged(prevProps)) {
      this.getClientState(this.props);
    }
  }

  render() {
    const query = rison.decode(this.props.location.query.q || '()');
    const chartView = this.props.location.query.view === 'chart';
    const mainView = !chartView ? /*#__PURE__*/
    _jsx(DocumentsList, { storeKey: "uploads" }) : /*#__PURE__*/

    _jsx(LibraryCharts, { storeKey: "uploads" });


    return /*#__PURE__*/(
      _jsx("div", { className: "row panels-layout" }, void 0, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, /*#__PURE__*/
      _jsx("title", {}, void 0, t('System', 'Uploads', null, false))), /*#__PURE__*/

      _jsx(UploadsHeader, {}), /*#__PURE__*/
      _jsx("div", { className: "content-holder uploads-viewer document-viewer with-panel with-header" }, void 0, /*#__PURE__*/
      _jsx("main", {}, void 0, /*#__PURE__*/
      _jsx(UploadBox, {}),

      mainView), /*#__PURE__*/

      _jsx(LibraryFilters, { uploadsSection: true, storeKey: "uploads" }), /*#__PURE__*/
      _jsx(ViewMetadataPanel, { storeKey: "uploads", searchTerm: query.searchTerm }), /*#__PURE__*/
      _jsx(SelectMultiplePanelContainer, { storeKey: "uploads" }), /*#__PURE__*/
      _jsx(ImportPanel, {}))));



  }
}